import { HangoutState } from '../state/HangoutState.js';
import { storageManager } from '../../../core/storage/index.js';
import { storage } from '../../../js/utils/storage.js';
import { $, css } from '../../../core/utils/dom.js';

const openLoginModal = async ({ forced = false, message } = {}) => {
    if (window.loginModalController?.show) {
        await window.loginModalController.init?.();
        await window.loginModalController.show?.(forced, message);
        return;
    }

    const { default: loginModalController } = await import('../../components/LoginModalController.js');
    await loginModalController?.init?.();
    await loginModalController?.show?.(forced, message);
};

const showLoginModalFallback = () => {
    const loginModal = $('#loginModal');
    if (loginModal) css(loginModal, 'display', 'flex');
};

export async function persistHangoutSessionBeforeLogin(context = 'unknown', extra = {}) {
    try {
        const hangoutConfig = await storageManager.getItem('currentHangoutConfig');
        if (!hangoutConfig) return;

        const hangoutState = HangoutState.getInstance();
        storage.set('hangoutSessionBeforeLogin', {
            ...hangoutConfig,
            returnToHangout: true,
            returnUrl: window.location.href,
            conversationId: hangoutState.getConversationId(),
            authContext: context,
            timestamp: Date.now(),
            ...extra
        });
    } catch (storageError) {
        console.error('hangout-auth-modals.js: Error storing hangout session state:', storageError);
    }
}

export async function showHangoutFreeAccountModal(context = 'unknown') {
    try {
        const { showFreeAccountModal } = await import('../../components/FreeAccountModal.js');
        await showFreeAccountModal(context);
    } catch (error) {
        console.error('hangout-auth-modals.js: Failed to show free account modal:', error);
        try {
            await openLoginModal({ forced: true });
        } catch {
            showLoginModalFallback();
        }
    }
}

export async function showHangoutLoginModal(context = 'unknown', message = 'Please log in to use voice features') {
    console.info(`hangout-auth-modals.js: Showing hangout login modal (${context})`);
    await persistHangoutSessionBeforeLogin(context);

    try {
        await openLoginModal({ forced: false, message });
    } catch (error) {
        console.error('hangout-auth-modals.js: Failed to show login modal:', error);
        showLoginModalFallback();
    }
}

export async function handleAuthenticationRequired() {
    console.info('hangout-auth-modals.js: Authentication required, showing free account modal');
    await persistHangoutSessionBeforeLogin('auth-required');
    await showHangoutFreeAccountModal('auth-required');
}
